var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-pagination',{attrs:{"total":_vm.pages.count,"current":_vm.pages.current,"rounded":_vm.rounded,"per-page":_vm.pages.per_page ? _vm.pages.per_page : '25',"aria-next-label":"Next page","aria-previous-label":"Previous page","aria-page-label":"Page","aria-current-label":"Current page"},on:{"change":_vm.setPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }